import { render } from "./HomeTelemetryIcon.vue?vue&type=template&id=08c38c9f"
import script from "./HomeTelemetryIcon.vue?vue&type=script&lang=js"
export * from "./HomeTelemetryIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__